@if (site) { @if (site.logoUrl) {
<atx-image
  class="image logo-filter"
  [ngClass]="{ 'm-0 pt-1 pb-1': selected }"
  [attr.data-e2e]="'site-selector-brand-image-' + site.title"
  [imageUrl]="site.logoUrl"
  [maxWidth]="imageMaxSizes.THUMBNAIL"
  failedLoadIconSize="1x"
></atx-image>
} @else {
<div class="text-center font-weight-bold text">
  {{ site.title }}
</div>
} }
